<!--
 * @Author: cryi.liu
 * @Date: 2020-05-15 13:55:58
 * @LastEditTime: 2020-06-20 18:12:14
 * @Description: 考生答题页面
 -->
<template>
  <div v-if="loaded" class="content">
    <template v-if="!isPreview">
      <current-exam-info
        :current-question-index="currentQuestionIndex"
        :current-question-type="currentQuestionType"
        :time-remaining="timeRemaining"
        />
      <div class="answer-area">
        <div class="topic">
          <p class="title">{{ showTitle }}</p>
          <video-player
            v-if="currentQuestionStemMediaType === 'mp4'"
            :media-path="currentQuestion.mediaInfoVO.mediaPath"
            :video-cover="currentQuestion.mediaInfoVO.videoCover" />
          <audio-player
            v-else-if="currentQuestionStemMediaType === 'mp3'"
            :media-path="currentQuestion.mediaInfoVO.mediaPath" />
          <image-player
            v-else-if="currentQuestionStemMediaType === 'jpg'"
            :center="false"
            :media-path="currentQuestion.mediaInfoVO.mediaPath" />
          <div
            v-else-if="currentQuestionStemMediaType === 'pdf'"
            class="look-media"
            @click="lookPdfMedia(currentQuestion.mediaInfoVO.mediaPath)">查看pdf多媒体文件</div>
        </div>
        <component
          :is="currentQuestionCom"
          :type="currentQuestionType"
          :index="currentQuestionIndex"
          :time-remaining="timeRemaining"
          @preview-media="previewMedia"></component>
      </div>
      <action-bar
        :questionNumber="currentQuestionIndex"
        @prev-question="prevQuestion"
        @next-question="nextQuestion"
        @preview-question="previewQuestion"
        @handler-submit="handlerSubmit" />
    </template>
    <preview
      v-else
      @back-paper="backPaper"
      @handler-submit="handlerSubmit"
      :library-info="libraryInfo.length > 0 ? libraryInfo : []" />

    <preview-media-modal
      :show="previewMediaModalShow"
      :media-path="previewMediaPath"
      :media-type="previewMediaType"
      :video-cover="previewMediaVideoCover"
      @close-modal="closeModalHandler" />

    <pdf-player-modal
      :show="previewPdfMediaModalShow"
      :media-type="previewMediaType"
      :url="previewMediaPath"
      @close-modal="previewPdfMediaModalShow = false" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import CurrentExamInfo from './components/CurrentExamInfo.vue';
import ActionBar from './components/ActionBar.vue';
import SingleChoice from './components/SingleChoice.vue';
import MultipleChoice from './components/MultipleChoice.vue';
import ShortArea from './components/ShortArea.vue';
import TextArea from './components/TextArea.vue';
import Preview from './components/Preview.vue';
import VideoPlayer from './components/VideoPlayer.vue';
import AudioPlayer from './components/AudioPlayer.vue';
import ImagePlayer from './components/ImagePlayer.vue';
import PreviewMediaModal from './components/PreviewMediaModal.vue';
import PdfPlayerModal from './components/PdfPlayerModal.vue';

const breadcrumb = [
  { text: '统考中心', href: '/tr/portal/index.jsp' },
  { text: '考生答题' },
];

export default {
  name: 'ExamAnswerOnline',
  props: {
    examId: { type: [Number, String], required: true },
  },
  components: {
    CurrentExamInfo,
    ActionBar,
    Preview,
    VideoPlayer,
    AudioPlayer,
    ImagePlayer,
    PreviewMediaModal,
    PdfPlayerModal,
  },
  data() {
    return {
      loaded: false,
      currentQuestionIndex: 0,
      timeRemaining: '',
      currentQuestionCom: null,
      isPreview: false,
      examTime: 0,
      timer: null,
      currentQuestionStemMediaType: '',
      previewMediaModalShow: false,
      previewMediaPath: '',
      previewMediaType: '',
      previewMediaVideoCover: '',
      previewPdfMediaModalShow: false,
    };
  },
  computed: {
    ...mapGetters({
      libraryInfo: 'onlineExamStore/libraryInfo',
    }),
    paperId() {
      return this.libraryInfo[this.currentQuestionIndex].paperId;
    },
    title() {
      return `${this.currentQuestionIndex + 1}、${this.libraryInfo[this.currentQuestionIndex].libraryVo.content ? this.libraryInfo[this.currentQuestionIndex].libraryVo.content : ''}（${this.libraryInfo[this.currentQuestionIndex].totalScore}分）`;
    },
    showTitle() {
      return this.title.replace(/\[\]/g, '__');
    },
    currentQuestionType() {
      return this.libraryInfo[this.currentQuestionIndex].libraryVo.questionType ? this.libraryInfo[this.currentQuestionIndex].libraryVo.questionType : '';
    },
    currentQuestion() {
      return this.libraryInfo[this.currentQuestionIndex].libraryVo
        ? this.libraryInfo[this.currentQuestionIndex].libraryVo
        : {};
    },
  },
  watch: {
    examId: {
      immediate: true,
      handler() {
        this.setProcessingShowState({ show: true });
        this.concurrentRequestThisPageData();
      },
    },
    currentQuestionType(type) {
      if (type === '单选' || type === '判断') {
        this.currentQuestionCom = SingleChoice;
      } else if (type === '多选' || type === '不定项选择') {
        this.currentQuestionCom = MultipleChoice;
      } else if (type === '简答') {
        this.currentQuestionCom = ShortArea;
      } else if (type === '填空') {
        this.currentQuestionCom = TextArea;
      }
    },
    currentQuestion({ mediaPath }) {
      const jpgReg = /jpg/;
      const pdfReg = /pdf/;
      const mp4Reg = /mp4/;
      const mp3Reg = /mp3/;

      if (jpgReg.test(mediaPath)) {
        this.currentQuestionStemMediaType = 'jpg';
        return;
      }

      if (mp4Reg.test(mediaPath)) {
        this.currentQuestionStemMediaType = 'mp4';
        return;
      }

      if (mp3Reg.test(mediaPath)) {
        this.currentQuestionStemMediaType = 'mp3';
        return;
      }

      if (pdfReg.test(mediaPath)) {
        this.currentQuestionStemMediaType = 'pdf';
        return;
      }

      this.currentQuestionStemMediaType = '';
    },
  },
  methods: {
    ...mapActions({
      setBreadcrumb: 'pageStore/invokeSetBreadcrumb',
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
      setExamInfo: 'onlineExamStore/invokeSetExamInfo',
      setLibraryInfo: 'onlineExamStore/invokeSetLibraryInfo',
    }),
    prevQuestion() {
      this.currentQuestionIndex -= 1;
    },
    nextQuestion() {
      this.currentQuestionIndex += 1;
    },
    previewQuestion() {
      this.isPreview = true;
    },
    backPaper() {
      this.isPreview = false;
    },
    lookPdfMedia(mediaPath) {
      this.previewMediaPath = mediaPath;
      this.previewMediaType = 'pdf';
      this.previewPdfMediaModalShow = true;
      // window.open(mediaPath, '_blank');
      // if (process.env.NODE_ENV === 'development') {
      //   window.open(`/#/tools/preview/pdf/${this.$base64.encode(mediaPath)}`, '_blank');
      // } else {
      //   window.open(`/examcentersite/#/tools/preview/pdf/${this.$base64.encode(mediaPath)}`, '_blank');
      // }
    },
    previewMedia({ mediaPath, realMediaPath, videoCover }) {
      const jpgReg = /jpg/;
      const pdfReg = /pdf/;
      const mp4Reg = /mp4/;
      const mp3Reg = /mp3/;

      if (jpgReg.test(mediaPath)) {
        this.previewMediaPath = realMediaPath;
        this.previewMediaType = 'jpg';
        this.previewMediaModalShow = true;
        return;
      }

      if (mp4Reg.test(mediaPath)) {
        this.previewMediaPath = realMediaPath;
        this.previewMediaType = 'mp4';
        this.previewMediaVideoCover = videoCover;
        this.previewMediaModalShow = true;
        return;
      }

      if (mp3Reg.test(mediaPath)) {
        this.previewMediaPath = realMediaPath;
        this.previewMediaType = 'mp3';
        this.previewMediaModalShow = true;
        return;
      }

      if (pdfReg.test(mediaPath)) {
        this.lookPdfMedia(realMediaPath);
        return;
      }

      alert('未知类型媒体文件！');
    },
    closeModalHandler() {
      this.previewMediaModalShow = false;
    },
    // 提交试卷
    async handlerSubmit() {
      const params = {
        paperId: this.paperId,
      };

      const result = await this.$http.answer.submitPaper(params);

      if (result.code === '200') {
        clearInterval(this.timer);
        alert('试卷提交成功');
        window.open('/mvc/page?loc=portal/gate&locale=zh&skipRefer=1', '_self');
      } else {
        alert(result.msg);

        if (result.msg === '您已在另一终端进入考试') {
          window.open('/mvc/page?loc=portal/gate&locale=zh&skipRefer=1', '_self');
        }
      }
    },
    // 保存考生考试剩余时间
    async saveRemaining() {
      const params = {
        timeRemaining: this.remainingTime,
        lastQuestionIndex: this.currentQuestionIndex + 1,
        paperId: this.paperId,
      };

      const result = await this.$http.answer.saveRemaining(params);

      if (result.code !== '200') {
        alert(result.msg);
      }
    },
    /**
     * 并发请求此页面首屏展示所有数据
     */
    concurrentRequestThisPageData() {
      const params = {
        examId: this.examId,
      };

      axios.all([
        this.$http.answer.examQuestion(params),
      ])
        .then(axios.spread((questionInfo) => {
          if (questionInfo.code === '200') {
            if(!questionInfo.data.examInfo.canEnterExam){
              alert('考试结束');
              window.open('/mvc/page?loc=portal/gate&locale=zh&skipRefer=1', '_self');
              return
            }
            this.setExamInfo({ examInfo: questionInfo.data.examInfo });
            this.setLibraryInfo({ libraryInfo: questionInfo.data.libraryInfo });

            if (questionInfo.data.examInfo.lastQuestionIndex) {
              this.currentQuestionIndex = questionInfo.data.examInfo.lastQuestionIndex - 1;
            }

            this.examTime = questionInfo.data.examInfo.examTime;

            if (questionInfo.data.examInfo.remainingTime) {
              this.timeRemaining = questionInfo.data.examInfo.remainingTime;
            } else {
              this.examTimeFormat();
            }

            this.examTimeCountDown();
          } else {
            alert(questionInfo.msg);

            if (questionInfo.msg === '考试已提交！') {
              window.open('/mvc/page?loc=portal/gate&locale=zh&skipRefer=1', '_self');
            }
          }

          this.loaded = true;
          this.setProcessingShowState({ show: false });
        }))
        .catch(() => {
          alert('数据请求失败');

          this.loaded = true;
          this.setProcessingShowState({ show: false });
        });
    },
    /**
     * 分钟格式化
     */
    examTimeFormat() {
      let hour = Math.floor(this.examTime / 60);
      hour = hour > 10 ? hour : `0${hour}`;
      let minute = this.examTime % 60;
      minute = minute > 10 ? minute : `0${minute}`;
      const second = '00';

      this.timeRemaining = `${hour}:${minute}:${second}`;
    },
    /**
     * 考试时间倒计时
     */
    examTimeCountDown() {
      // 时分秒转换为时间戳
      const hour = this.timeRemaining.split(':')[0];
      const min = this.timeRemaining.split(':')[1];
      const sec = this.timeRemaining.split(':')[2];
      let remainingTimCount = Number(hour * 3600) + Number(min * 60) + Number(sec);
      // 时间戳的只转为时分秒
      this.timer = setInterval(() => {
        remainingTimCount -= 1;
        let hours = parseInt((remainingTimCount % (60 * 60 * 24)) / (60 * 60), 10);
        let minutes = parseInt((remainingTimCount % (60 * 60)) / 60, 10);
        let seconds = remainingTimCount % 60;
        hours = hours < 10 ? `0${hours}` : hours;
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        seconds = seconds < 10 ? `0${seconds}` : seconds;
        this.timeRemaining = `${hours}:${minutes}:${seconds}`;

        if (remainingTimCount === 0) {
          alert('考试时间到，提交试卷');
          clearInterval(this.timer);
          // 时间到了自动提交试卷
          this.handlerSubmit();
        }
      }, 1000);
    },
    /**
     * 统一绑定事件
     */
    bindEvent() {
      this.noOperationOnMonitorPage();
      this.clickBrowserFallback();
    },
    /**
     * 监听页面无操作
     */
    noOperationOnMonitorPage() {
      let lastOperateTime = new Date();
      const SCREENSAVER_TIME = 60 * 1000;

      const afterOperate = () => {
        lastOperateTime = new Date();
        const thisOperateTime = lastOperateTime;

        setTimeout(() => {
          if (thisOperateTime === lastOperateTime) {
            this.saveRemaining();
          }
        }, SCREENSAVER_TIME);
      };

      window.addEventListener('mousedown', afterOperate, false);
      window.addEventListener('scroll', afterOperate, false);
      window.addEventListener('keypress', afterOperate, false);
    },
    /**
     * 监听浏览器回退事件
     */
    clickBrowserFallback() {
      window.onpagehide = function () {
        this.saveRemaining();
      };
    },
  },
  created() {
    this.setBreadcrumb({
      breadcrumb,
    });

    this.bindEvent();
  },
  beforeDestroy() {
    this.saveRemaining();
    clearInterval(this.timer);
    window.onpagehide = null;
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: 10px 20px;
  margin-bottom: 0;

  > .answer-area {
    margin: 20px 0;
    width: calc(100% - 32px);

    > .topic {
      padding-bottom: 12px;
      border-bottom: 1px dashed #ddd;

      > .title {
        padding-bottom: 12px;
        font-size: 14px;
      }

      > .look-media {
        display: inline-block;
        color: #0C8CCA;
        font-size: 12px;
        cursor: pointer;
        padding: 4px 8px;
        background-color: rgba(12, 140, 202, .1);
        border-radius: 6px;
      }
    }
  }
}
</style>
